<template>
    <el-upload
            :drag="drag"
            :action="url"
            :headers="{'Authorization': token}"
            :data="data"
            :on-success="handleSuccess"
            :on-remove="handleRemove"
            :on-error="handleError"
            :file-list="fileList"
            :list-type="listType"
            :limit="limit"
            :multiple="multiple"
            :show-file-list="showFileList"
            ref="upload">
        <slot name="content">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        </slot>
    </el-upload>
</template>

<script>
    import userInfoHelper from 'common/userInfo';

    export default {
        name: 'Upload',
        props: {
            value: {type: Array, default: []},
            data: Object,
            showFileList: {type: Boolean, default: true},
            multiple: {type: Boolean, default: true},
            listType: {type: String, default: 'picture'},
            url: {type: String, default: '/admin/common/upload'},
            drag: {type: Boolean, default: true},
            limit: {type: Number, default: 1},
        },
        data() {
            return {
                token: userInfoHelper.get().accessToken
            };
        },
        computed: {
            fileList() {
                return this.value
                    ? this.value.map(item => {
                    return {name: item, url: item};
                }):[];
            }
        },
        methods: {
            handleSuccess(file) {
                if (file.code === 0) {
                    this.value.push(file.data);
                    this.$emit('change', this.value);
                    this.$emit('input', this.value);
                    this.$parent.$emit('el.form.change', this.value);
                } else {
                    this.$message.error(file.msg);
                    this.handleRemove();
                }
            },
            handleError() {
                this.handleRemove();
            },
            handleRemove(file, fileList) {
                this.value.splice(this.value.indexOf(file.url), 1);
                this.$emit('change', this.value);
                this.$emit('input', this.value);
                this.$parent.$emit('el.form.change', this.value);
            },
            clearFiles() {
                this.value.splice(0, this.value.length);
                this.$emit('change', this.value);
                this.$emit('input', this.value);
                this.$parent.$emit('el.form.change', this.value);

            }

        },
        created() {
        }
    };
</script>

<style lang="less" scoped>
</style>
